export * from "./widget-text-config-page.view";
